import {Component, EventEmitter, Input, OnInit, Output} from "@angular/core";
import {getProcessTypeForStandard, Order, ProcessType, Product, StandardName} from "../../../store/state/order.state";
import {AdditionalQuestionsData, BinaryQuestionData, TextQuestionData} from "../../../store/actions/order.actions";
import {ProductAdditionalQuestionsFormService} from "./product/product-additional-questions-form.service";
import {TranslateService} from "@ngx-translate/core";
import {AuthenticationService} from "../../../authentication/authentication.service";

@Component({
    selector: 'additional-questions',
    templateUrl: './additional-questions.template.html',
    styleUrls: ['./additional-questions.style.scss'],
    standalone: false
})
export class AdditionalQuestionsComponent implements OnInit {

	@Input() order: Order;
	@Input() additionalQuestionsData: AdditionalQuestionsData;
	@Input() copyable = true;
	@Output() copyAnswers$: EventEmitter<Product> = new EventEmitter<Product>();

	clientLogged: boolean;

	private productVisibility: Map<StandardName, boolean>;

	constructor(private formService: ProductAdditionalQuestionsFormService, private translateService: TranslateService,
				private authService: AuthenticationService) {
		const productVisibility: ReadonlyArray<any> = Object.getOwnPropertyNames(StandardName).map(standard => [standard, true]);
		this.productVisibility = new Map(productVisibility);
	}

	ngOnInit(): void {
		// in OnInit this works and clears form service state -> in OnDestroy there is ValueHasChanged exception :/
		this.formService.destroy();
		this.clientLogged = this.authService.isLoggedUserClient(false)
	}

	isVisible(product: Product): boolean {
		return this.productVisibility.has(product.standard.name) && this.productVisibility.get(product.standard.name);
	}

	toggleVisibility(product: Product) {
		if (this.productVisibility.has(product.standard.name)) {
			this.productVisibility.set(product.standard.name, !this.productVisibility.get(product.standard.name));
		}
	}

	textQuestionsFor(product: Product): TextQuestionData[] {
		return this.additionalQuestionsData.productData.find(data => data.standardName === product.standard.name).textQuestions;
	}

	binaryQuestionsFor(product: Product): BinaryQuestionData[] {
		return this.additionalQuestionsData.productData.find(data => data.standardName === product.standard.name).binaryQuestions;
	}

	// needed for angular to not rebuild component added by *ngFor
	trackByProductsFcn(index: number, item: Product) {
		return index;
	}

	shouldShowCopyButtonFor(product: Product, productIndex: number): boolean {
		return product.standard.name != StandardName.ISO_27701 && productIndex > 0 && this.order.products.length > 1;
	}

	isTransfer(product: Product): boolean {
		return getProcessTypeForStandard(product.standard) === ProcessType.TRANSFER;
	}

	getCopyButtonText(): string {
		return this.translateService.instant('common.copy') + this.order.products[0].standard.name.replace('_', ' ');
	}

	showAllProductsSections() {
		this.order.products.filter(product => !this.isVisible(product)).forEach(product => {
			this.toggleVisibility(product)
			setTimeout(() => this.formService.triggerValidations(), 100);
		});
	}
}
